// brands
import {
  faFacebookSquare,
  faInstagram,
  faLinkedin,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons';

// regular
import {
  faCheckSquare as farCheckSquare,
  faSquare      as farSquare,
  faCopy        as farCopy,
  faQuestionCircle as farQuestionCircle,
} from '@fortawesome/free-regular-svg-icons';

// solid
import {
  faAngleDown,
  faBuilding,
  faChartLine,
  faCheckCircle,
  faMoneyBillAlt,
  faFileAlt,
  faFile,
  faCog,
  faPhone,
  faSpellCheck,
  faTachometerAlt,
  faChalkboardTeacher,
  faExclamationCircle,
  faInfoCircle,
  faCheck,
  faSquare,
  faTimes,
  faUserCircle,
  faExpand,
  faCompress,
  faArrowAltCircleDown,
  faRedo,
  faUndo,
  faImage,
  faSignInAlt,
  faPlayCircle,
  faFileSignature,
  faPaperPlane,
  faChartBar,
  faBars,
  faMobileAlt,
  faPhoneAlt,
  faUser,
  faSave,
  faHistory,
  faTable,
  faSearch,
  faCopy,
  faLongArrowAltUp,
  faLongArrowAltDown,
  faUserGraduate,
  faEye,
  faEdit,
  faTimesCircle,
  faUpload,
  faPrint,
  faFileExcel,
  faPlus,
  faStar,
  faAngleRight,
  faScroll,
  faICursor,
  faMagic,
  faCalendarAlt,
  faCalendarCheck,
  faClock,
  faTh,
  faThList,
  faSyncAlt,
  faTrashAlt,
  faQuestionCircle,
  faPen,
  faLongArrowAltLeft,
  faTrophy,
  faEnvelope,
  faLevelUpAlt,
  faLevelDownAlt,
  faQuestion,
  faHome,
  faPenNib,
  faPlusSquare,
  faMinusSquare,
  faExternalLinkAlt,
  faWrench,
  faThumbsUp,
  faThumbsDown,
  faBan,
  faUserSlash,
  faEnvelopeOpen,
  faLongArrowAltRight,
  faExchangeAlt,
  faDownload,
  faExclamationTriangle,
  faLock,
  faBalanceScale,
  faCoins,
  faSmile,
  faFrown,
  faMeh,
  faLaughWink,
  faEyeSlash,
  faFont,
  faToggleOff,
  faToggleOn,
  faDizzy,
  faAngry,
  faFilePdf,
  faBox,
  faBook,
  faArrowCircleDown,
  faChevronRight,
  faChevronLeft,
  faChevronDown,
  faArrowCircleRight,
  faArrowCircleLeft,
  faCircle,
  faHandshake,
  faChartPie,
  faBookOpen,
  faRuler,
  faUniversalAccess,
  faHourglass,
  faFileCsv,
  faRobot,
  faNetworkWired,
  faHourglassHalf,
  faMinus,
  faFastForward,
  faFastBackward,
  faBroom,
  faList,
} from '@fortawesome/free-solid-svg-icons';


export const solidIcons = [
  faAngleDown,
  faBuilding,
  faChartLine,
  faCheckCircle,
  faCog,
  faFile,
  faFileAlt,
  faMoneyBillAlt,
  faPhone,
  faSpellCheck,
  faTachometerAlt,
  faChalkboardTeacher,
  faSquare,
  faCheck,
  faInfoCircle,
  faExclamationCircle,
  faTimes,
  faUserCircle,
  faExpand,
  faCompress,
  faImage,
  faUndo,
  faRedo,
  faArrowAltCircleDown,
  faArrowCircleRight,
  faArrowCircleLeft,
  faSignInAlt,
  faPlayCircle,
  faFileSignature,
  faPaperPlane,
  faPhoneAlt,
  faMobileAlt,
  faBars,
  faChartBar,
  faUser,
  faSave,
  faHistory,
  faTable,
  faSearch,
  faCopy,
  faUserGraduate,
  faEye,
  faPrint,
  faUpload,
  faTimesCircle,
  faEdit,
  faFileExcel,
  faFileCsv,
  faPlus,
  faMinus,
  faFastForward,
  faFastBackward,
  faLongArrowAltUp,
  faLongArrowAltDown,
  faStar,
  faAngleRight,
  faICursor,
  faScroll,
  faMagic,
  faClock,
  faCalendarAlt,
  faQuestionCircle,
  faThList,
  faSyncAlt,
  faTrashAlt,
  faLongArrowAltLeft,
  faTh,
  faPen,
  faTrophy,
  faEnvelope,
  faEnvelopeOpen,
  faQuestion,
  faHome,
  faPenNib,
  faPlusSquare,
  faMinusSquare,
  faExternalLinkAlt,
  faWrench,
  faThumbsUp,
  faThumbsDown,
  faBan,
  faUserSlash,
  faLevelUpAlt,
  faLevelDownAlt,
  faExchangeAlt,
  faLongArrowAltRight,
  faDownload,
  faExclamationTriangle,
  faLock,
  faBalanceScale,
  faCoins,
  faSmile,
  faFrown,
  faMeh,
  faLaughWink,
  faEyeSlash,
  faFont,
  faBox,
  faBook,
  faArrowCircleDown,
  faDizzy,
  faAngry,
  faToggleOff,
  faToggleOn,
  faFilePdf,
  faCalendarCheck,
  faChevronLeft,
  faChevronRight,
  faChevronDown,
  faChartPie,
  faBookOpen,
  faRuler,
  faCircle,
  faUniversalAccess,
  faHandshake,
  faHourglass,
  faRobot,
  faNetworkWired,
  faHourglassHalf,
  faBroom,
  faList,
];

export const regularIcons = [
  farSquare,
  farCheckSquare,
  farCopy,
  farQuestionCircle,
];

export const brandIcons = [
  faFacebookSquare,
  faInstagram,
  faLinkedin,
  faYoutube,
];
